import React, { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { HiBars2 } from 'react-icons/hi2';
import { Dropdown, OverlayTrigger, Popover } from 'react-bootstrap';
import { Dots } from '../SvgIcon';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useWindowSize from './useWindowSize';
import { newServicesAction } from '../../_actions';
import { useDispatch, useSelector, connect } from 'react-redux';
import CopyLinkButton from '../shared/shareLinks';

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

function ServiceItem({ item, category, deleteService, mobileDotServicePopup, onOpenDetail, user, isSalonOwner, isSelfEmployed }) {
  // Get currency symbol from Redux state
  const currencySymbol = user?.userInfo?.hairdresser?.currencySymbol || '£';
  const { 
    attributes, 
    listeners, 
    setNodeRef, 
    transform, 
    transition,
    isDragging 
  } = useSortable({ 
    id: item.id,
    data: {
      type: 'item',
      category: category,
      item: item
    }
  });
  const { width } = useWindowSize();
  const history = useHistory();
  const dispatch = useDispatch();
  console.log("widthserviceitem",item,category)
  const [openAlert,setOpenAlert]=useState(false)
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };
  const OpenAlert=()=>{
    alert("hello radha")
  }
  
  // Get the actual service ID (use originalId for featured services, or id for regular services)
  const getServiceId = () => item.originalId || item.id;
  
  const listHairdresseData =(id)=>{
    // debugger
    let payload = { }
    dispatch(newServicesAction.listHairDresserData(payload))
      .then((res) => {
        console.log("listHairdresserlistHairdresser3333", res);
      })
      .catch((error) => {
        console.error("Error edit category:", error);
      });
      history.push(`/edit-services/${id}`)
  }
  return (
    // <div 
    //   ref={setNodeRef} 
    //   style={style} 
    //   className="item"
    //   data-dragging={isDragging}
    // >
    <div 
      className="service-item" 
      ref={setNodeRef} 
      style={style} 
      data-dragging={isDragging}
      onClick={() => {
        if (onOpenDetail) {
          onOpenDetail(item);
        }
      }}
      >
        <HiBars2 className="menu-icon service-menu-icon drag-handle" 
            {...attributes} {...listeners} />
      {/* <div className="drag-handle" {...attributes} {...listeners}>
        <svg viewBox="0 0 20 20" width="12">
          <path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"></path>
        </svg>
      </div> */}
       <div className="_text">
              <div className="service-row__main">
                <h3 className="service-row__title">
                  {item.name}
                  <span className="service-row__title-meta">
                    {' · '}
                    {isSalonOwner && item?.staffCount > 1 && item?.fromDuration != null && item?.duration != null && Number(item.fromDuration) !== Number(item.duration)
                      ? <>{Math.min(Number(item.fromDuration), Number(item.duration))}m - {Math.max(Number(item.fromDuration), Number(item.duration))}m</>
                      : <>{item?.duration}m</>
                    }
                    {item?.processingTime ? <> · {item?.processingTime}m processing time</> : ''}
                    {item?.finishingTime ? <> · {item?.finishingTime}m finishing</> : ''}
                  </span>
                  {item?.notAssigned == true ? <span className="_not_aasigned">Not assigned</span> : ''}
                </h3>
                {item?.description ? <p className="descption">{item?.description}</p> : ''}
              </div>
              <div className="service-row__aside">
                <div className="service-row__price-line">
                  <CopyLinkButton type="service" id={getServiceId()} className="share-link-btn--reveal share-link-btn--sm" title="Copy service link" />
                  <b className="service-row__price">
                    {isSalonOwner && item?.staffCount > 1 && item?.fromPrice != null && item?.price != null && Number(item.fromPrice) !== Number(item.price)
                      ? <>{currencySymbol}{Math.min(Number(item.fromPrice), Number(item.price)).toFixed(2)} - {currencySymbol}{Math.max(Number(item.fromPrice), Number(item.price)).toFixed(2)}</>
                      : <>{currencySymbol}{Number(item?.price || 0).toFixed(2)}</>
                    }
                  </b>
                </div>
                {(item?.deposit || item?.fromDeposit) ? (
                  <span className="service-row__deposit">
                    {isSalonOwner && item?.staffCount > 1 && item?.fromDeposit != null && item?.deposit != null && Number(item.fromDeposit) !== Number(item.deposit)
                      ? <>{currencySymbol}{Math.min(Number(item.fromDeposit), Number(item.deposit))} - {currencySymbol}{Math.max(Number(item.fromDeposit), Number(item.deposit))} deposit</>
                      : item?.deposit ? <>{currencySymbol}{item?.deposit} deposit</> : ''
                    }
                  </span>
                ) : ''}
                {isSalonOwner && item?.staffPreview?.length > 0 && (
                  <div className="staff-circles">
                    {item.staffPreview.map((staff, idx) => (
                      <div key={idx} className="staff-circle" title={staff.name}>
                        <span>{getInitials(staff.name)}</span>
                      </div>
                    ))}
                    {item.staffCount > 3 && (
                      <div className="staff-circle staff-circle-more">
                        <span>+{item.staffCount - 3}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
        </div>
        

      {/* <div className="item-content">
        <h4>{item.name}</h4>
        <p>
          <span>Duration:</span>
          <span>{item.duration} mins</span>
        </p>
        <p>
          <span>Price:</span>
          <span>${item.price}</span>
        </p>
        <p>
          <span>Deposit:</span>
          <span>${item.deposit}</span>
        </p>
        <p>{item.description}</p>
      </div> */}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default connect(mapStateToProps)(ServiceItem);
